// redux
import { useNopimsBasket } from "../nopimsBasketSlice";
// common
import * as Forms from "../../../common/forms/BootstrapForms";
import { IValidationModel } from "../../../common/validation/ValidationModel";
// me
import { IRootViewModel, ICustomerDetailsViewModel } from "./models/models";
import SubmitViewDetails from "./SubmitViewDetails";

interface IProps {
    vm: IRootViewModel;
    setVm: (vm: IRootViewModel) => void;
    validation: IValidationModel;
    onSubmit: () => void;
    onCancel: () => void;
}

export default function SubmitView(props: IProps): React.JSX.Element {
    const { vm, setVm, validation, onSubmit, onCancel } = props;

    const { items } = useNopimsBasket();

    function handleDetailsChanged(values: ICustomerDetailsViewModel) {
        setVm(vm.customerDetailsChanged(values));
    }

    return (
        <>
            <Forms.Row>
                <Forms.HalfColumn>
                    You are requesting copies of <b>{items.length.toString()} documents</b>.
                </Forms.HalfColumn>
            </Forms.Row>
            <SubmitViewDetails vm={vm} validation={validation} onChange={handleDetailsChanged} onCancel={onCancel} onSubmit={onSubmit} />
        </>
    );
}
